var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStablecoinSupplyRatio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BCtrend",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stablecoin-Supply-Ratio",
    transform: "translate(-60.000000, -370.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11594204,9.85507247 L8.11594204,11.5942029 L17.7971014,11.5942029 C17.1014493,15.4202899 14.0289855,17.9710145 9.85507247,17.9710145 C5.04347826,17.9710145 1.73913043,14.6666667 1.73913043,9.85507247 C1.73913043,5.68115943 4.28985508,2.60869565 8.11594204,1.91304348 L8.11594204,9.85507247 L9.85507247,9.85507247 L9.85507247,-1.54465812e-15 C4.46376812,-1.54465812e-15 -1.54465812e-15,4.40579709 -1.54465812e-15,9.85507247 C-1.54465812e-15,15.2463768 4.40579709,19.7101449 9.85507247,19.7101449 C15.2463768,19.7101449 19.7101449,15.2463768 19.7101449,9.85507247 L8.11594204,9.85507247 Z M19.1304348,8.69565217 L19.7101449,8.63768117 C19.7101449,3.82608696 15.884058,-1.54465812e-15 11.0724638,-1.54465812e-15 L11.0144927,1.73913043 L11.0724638,1.73913043 L11.0144927,6.95652174 L11.0144927,7.53623187 L11.0724638,7.53623187 L11.0144927,8.69565217 L19.1304348,8.69565217 Z M12.7536232,1.85507247 C15.3043478,2.43478261 17.5072464,4.69565217 17.9710145,6.95652174 L12.7536232,6.95652174 L12.7536232,1.85507247 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStablecoinSupplyRatio);
export default __webpack_public_path__ + "static/media/stablecoin-supply-ratio.c1fa9966f44d5954670f13e1c8e04938.svg";
export { ForwardRef as ReactComponent };